declare var jQuery: any;

/**
 * Edit page
 *
 * @return void
 */
const editPage = () => {
  // Get DATAGENT_COUPON
  const { label, coupon } = (<any>window).DATAGENT_COUPON;

  // Create new chat with coupon button.
  let newButton = jQuery('<a/>', {
    class: 'page-title-action',
    href: coupon.convert_url.replace(/&amp;/g, '&'),
    text: label.chat_with_coupon,
  });
  newButton.insertAfter('.page-title-action');
};

// Add buttons on WPForms overview page
jQuery(document).ready(function () {
  // Get action from $_GET['action']
  const urlParams = new URLSearchParams(window.location.search);
  const action = urlParams.get('action');

  if (action === 'edit') {
    // Check if action is edit
    editPage();
  }
});
